/**
 * @generated SignedSource<<6653a012c00f3f33c15e80328a3ed7ed>>
 * @relayHash 635275d9951671af0742660724a15567
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 076d66dc0d0c1f69a88c88c422a713cd3cc1ebb8a2f03b5e66b79df6b1d716c1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "076d66dc0d0c1f69a88c88c422a713cd3cc1ebb8a2f03b5e66b79df6b1d716c1",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
